import type React from 'react';

import type { MultiLang } from '../../../../config';
import Functions from '../../../../functions';
import type { ItemBasicChangeLog } from '../../../lib/ItemUtil';
import DateTime from './DateTime';

interface Props {
    lang: MultiLang;
    changelog: ItemBasicChangeLog[];
}

const ChangeLog: React.FC<Props> = (props) => {
    const { lang, changelog } = props;
    if (changelog.length === 0) {
        return null;
    }
    const elements = changelog.map((value, _i) => {
        return (
            <tr key={`${value.log_date}:${value.log}`}>
                <td>
                    <DateTime lang={lang} date={value.log_date} onlyDate={true} />
                </td>
                <td>{Functions.mlang(value.log, lang)}</td>
            </tr>
        );
    });
    return (
        <table>
            <tbody>{elements}</tbody>
        </table>
    );
};

export default ChangeLog;
